import { Layout } from 'components/Layout';
import { WideSection } from 'components/Section';

import { VacanciesList } from './VacanciesList';
import { Text, VacanciesTitle, VacanciesShortList } from './Careers.style';

import { vacancies } from './constants';
import { PageMeta } from 'constants/pages';
import { MetaHead } from 'components/MetaHead';

const Careers: React.FC<PageMeta> = (pageMeta) => (
  <Layout>
    <MetaHead pageMeta={pageMeta} />
    <WideSection pt={[10]} pb={[6.5, 7.5]} px={[2, 2.5, 5, 0, 0]}>
      <h2>.. Bring AI forward !</h2>
      <Text mt={[3]}>
        AILiveSim is a Helsinki-based startup that offers a state-of-the-art simulation platform
        bringing together AI, robotics, and video game technology. We are active in several
        industries such as automotive, mining, maritime, robotics, and defense. With controlled
        simulations, AILiveSim accelerates the development cycle and provides a scalable solution
        for testing, training, and validating autonomous machines and Artificial Intelligence
        algorithms.
      </Text>
      <Text mt={[4]}>
        Join us and dive into cutting-edge projects at the forefront of technology. As a close-knit
        team, we are dedicated to your personal growth, offering continuous learning opportunities
        and a supportive environment. Enjoy team lunches that foster collaboration(and fun!), a
        subscription to gift cards for your personal treats, and access to our fully equipped office
        gym. We are a remote first company, but we also offer a hybrid working model to provide
        flexibility in work arrangements.
      </Text>

      <Text mt={[4]}>
        We are currently looking for exceptional candidates, self-driven and with a strong
        motivation. We value experience and education but we also know that talent doesn&apos;t
        necessarily comes with the number of years.
      </Text>
      <Text mt={[4]}>
        We also believe in the power of the team, so a team player that is able to communicate and
        brainstorm is considered a must.
      </Text>
      <Text mt={[4]}>
        <VacanciesTitle>We are looking to fill several roles:</VacanciesTitle>
        <VacanciesShortList>
          {vacancies.map((item) => (
            <li key={item.id}>
              <a href={`#${item.id}`}>{item.title}</a>
            </li>
          ))}
        </VacanciesShortList>
      </Text>
      <Text mt={[4]}>
        If you think you can contribute, contact us at jobs@ailivesim.com with your CV and
        motivation, we&apos;re happy to hear from you.
      </Text>
      <VacanciesList />
    </WideSection>
  </Layout>
);

export default Careers;
